const IGNORED_FIREBASE_POPUP_ERROR_CODES = new Set([
  'auth/cancelled-popup-request',
  'auth/popup-closed-by-user',
])

const getFirebaseErrorCode = (error: unknown): string | null => {
  if (!error || typeof error !== 'object' || !('code' in error)) return null

  const { code } = error as { code?: unknown }

  return typeof code === 'string' ? code : null
}

export const getFirebaseErrorLogMessage = (error: unknown): string => {
  const errorCode = getFirebaseErrorCode(error)

  if (error instanceof Error) {
    return errorCode ? `${errorCode}: ${error.message}` : error.message
  }

  return errorCode || String(error)
}

export const shouldIgnoreFirebasePopupError = (error: unknown): boolean => {
  const errorCode = getFirebaseErrorCode(error)

  return Boolean(errorCode && IGNORED_FIREBASE_POPUP_ERROR_CODES.has(errorCode))
}
